<script setup>
import {computed} from "vue";
import {useStore} from "@/store/store";
import {useRouter} from "@/routes";

const store = useStore()
const router = useRouter()

let tableHeaders = [
  {
    text: "EAN",
    sortable: false,
    value: "ean"
  },
  {
    text: "Titel",
    sortable: false,
    value: "title"
  },
  {
    text: "Menge",
    sortable: false,
    value: "quantity"
  }
]

let storageLocations = computed(() => {
  let productsWithStorageLocations = store.state.productsWithStorageLocations

  const result = []

  for (const i in productsWithStorageLocations) {
    const product = productsWithStorageLocations[i]
    result.push({
      ean: product.ean,
      title: product.title,
      quantity: product.storageLocations[0].quantity
    })
  }

  return result

});
</script>

<template>
  <v-main class="ml-5 mt-5">
    <v-row class="flex-grow-1 mb-1 pl-3 mt-1">
      <div class="text-h4 transition-swing" v-text="'Abfrage'"></div>
    </v-row>
    <v-row>
      <v-col sm="12" md="12" lg="6" xl="6">
        <v-card class="pa-3 text-body-1">
            Lagerplatz: {{ router.currentRoute.params["location"] }}
        </v-card>
      </v-col>
    </v-row>
    <v-row class="mt-5 mr-5">
      <v-col sm="12" md="12" lg="6" xl="6">
        <v-data-table
            disable-pagination
            :hide-default-footer="true"
            no-data-text="keine Artikel im Lagerplatz"
            :headers="tableHeaders"
            :items="storageLocations"
            class="elevation-1"
            mobile-breakpoint="0"
        />
      </v-col>

    </v-row>
  </v-main>
</template>

<style scoped>

</style>